module.exports = __webpack_public_path__ + "static/media/alteration-service.0a4885a7.webp";